export var BodyPartPickerSide;
(function (BodyPartPickerSide) {
    BodyPartPickerSide["Front"] = "front";
    BodyPartPickerSide["Back"] = "back";
    BodyPartPickerSide["Both"] = "both";
})(BodyPartPickerSide || (BodyPartPickerSide = {}));
export var BodyPartPickerGender;
(function (BodyPartPickerGender) {
    BodyPartPickerGender["Male"] = "male";
    BodyPartPickerGender["Female"] = "female";
})(BodyPartPickerGender || (BodyPartPickerGender = {}));
//# sourceMappingURL=types.js.map